import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as QuestionsAccordion } from './Accordion.vue';

export type QuestionsAccordionVariant = 'light' | 'dark';

export interface Question {
	question: string;
	answer: string;
}

export interface QuestionsAccordionEmits {
	(
		e: 'question-clicked',
		payload: { question: string; position: number }
	): void;
}
export interface QuestionsAccordionProps {
	modelValue?: string;
	questions?: Question[];
	accordionItemClass?: HTMLAttributes['class'];
	accordionTriggerAs?: string;
	variant?: QuestionsAccordionVariant;
}

export const questionsAccordionItemVariants = cva('no-underline', {
	variants: {
		variant: {
			light: 'border-white-dark-2 text-primary',
			dark: 'border-t border-b-0 border-[#3A3A3A] text-[#FAFAFA]'
		}
	},
	defaultVariants: { variant: 'light' }
});

export const questionsAccordionTriggerVariants = cva('text-left', {
	variants: {
		variant: {
			light:
				'gap-3 border-b border-white-dark-2 py-4 pl-4 pr-3 font-matter-sq text-base font-normal leading-normal tracking-[-0.32px] text-primary md:p-6 md:text-lg',
			dark: 'group min-h-16 w-full gap-4 border-none bg-transparent px-0 py-5 text-[18px] font-medium text-[#FAFAFA]'
		}
	},
	defaultVariants: { variant: 'light' }
});

export const questionsAccordionContentVariants = cva('', {
	variants: {
		variant: {
			light:
				'p-4 text-sm font-normal leading-[175%] text-primary md:px-11 md:py-8 md:text-base',
			dark: 'pt-0 pr-10 pb-6 pl-0 text-[16px] leading-[1.7] text-[#D4D4D4]'
		}
	},
	defaultVariants: { variant: 'light' }
});
